import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class Types extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: '',
        };

        this.changeText = this.changeText.bind(this);
        this.saveToTrain = this.saveToTrain.bind(this);
    }

    changeText(e, value) {
        this.setState({
            text: value,
        });
    }

    saveToTrain() {
        this.props.addNewType(this.state.text);

        this.setState({
            text: '',
        });
    }

    render() {
        const { text } = this.state;
        const { types, selectedType, selectType } = this.props;

        return (
            <div className='paper-block margin-10'>
                <span className='name-block absolute small-name'>Types</span>

                <div className="row">
                    {
                        types.length > 0
                        ?
                            <div className="col-xs-6">
                                <SelectField
                                    floatingLabelText='Types'
                                    value={selectedType}
                                    floatingLabelStyle={{ fontSize: '12px' }}
                                    onChange={selectType}
                                >
                                    {
                                        types.map((type, key) => {
                                            return <MenuItem
                                                value={type}
                                                primaryText={type}
                                                key={key}
                                            />
                                        })
                                    }
                                </SelectField>
                            </div>
                            :
                            ''
                    }

                </div>

                <div className="row">
                    <div className="col-xs-6">
                       <TextField
                            floatingLabelText='New type'
                            value={text}
                            onChange={this.changeText}
                            floatingLabelStyle={{ fontSize: '12px' }}
                       />
                    </div>
                    <div className="col-xs-6">
                        <RaisedButton
                            label='Add to types'
                            labelStyle={{ fontSize: '12px' }}
                            disabled={text.length === 0}
                            onClick={this.saveToTrain}
                            primary
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Types.propTypes = {

};

export default Types;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Train/Sidebar/Types.jsx